import { NgModule } from "@angular/core";
import { AceNumberPipe } from "./aceNumber.pipe";
import { AceCommaNewlinePipe } from "./aceCommaNewline.pipe";
import { AceFileSizePipe } from "./aceFileSize.pipe";
import { AceSanitizeHTML } from "./sanitizeHTML.pipe";
import { AceBase64ImagePipe } from "./aceBase64Image.pipe";

@NgModule({
  declarations: [ AceNumberPipe, AceCommaNewlinePipe, AceFileSizePipe, AceSanitizeHTML, AceBase64ImagePipe],
  imports: [],
  exports: [ AceNumberPipe, AceCommaNewlinePipe, AceFileSizePipe, AceSanitizeHTML, AceBase64ImagePipe],
  providers: []
})
export class CustomPipesModule {
}
